import { SET_SEARCH_FILTER_ACTION } from "./constants";
import { DASHBOARD_FILTER, USER_LIST_FILTER } from "../Utils/Constants";

const INITIAL_STATE = {
  dashboardSearchFilter: {
    ...DASHBOARD_FILTER,
  },
  userListSearchFilter: {
    ...USER_LIST_FILTER,
  },
  searchPage: "",
};
export default function searchFilterReducer(state = INITIAL_STATE, action) {// NOSONAR
  switch (action.type) {
    case SET_SEARCH_FILTER_ACTION.DASHBOARD:
      return {
        ...state,
        dashboardSearchFilter: action.searchFilter,
        searchPage: action.searchPage,
      };
    case SET_SEARCH_FILTER_ACTION.USER_LIST:
      return {
        ...state,
        userListSearchFilter: action.searchFilter,
        searchPage: action.searchPage,
      };
    // case CLEAR_SEARCH_FILTER_ACTION:
    //   return INITIAL_STATE;
    default:
      return state;
  }
}
